<span class="badge-foundation badge-foundation--color-{{ color }} badge-foundation--{{ modifier }}">
  <ftr-icon *ngIf="icon" [icon]="icon" [size]="'Text'"></ftr-icon>
  <span class="badge-foundation__text" *ngIf="text">{{ text }}</span>
</span>
